import { cx } from "@emotion/css";
import { ThumbsDown, ThumbsUp } from "lucide-react";
import { useTranslation } from "react-i18next";

import { TextButton } from "src/components/Default/LekUI/Button";
import type { AnimateExitFn } from "./Flashcard";

interface KnowDontKnowControllerProps {
	animateExit: AnimateExitFn;
	resolveFlashcard: (grade: number) => void;
}

export function KnowDontKnowController({
	animateExit,
	resolveFlashcard,
}: KnowDontKnowControllerProps) {
	const { t } = useTranslation();

	return (
		<div className="flashcard-app--controller">
			<TextButton
				onClick={() => animateExit("left", "red", () => resolveFlashcard(0))}
				className={cx("error-text-btn", "flashcard-app--option")}
				data-test-id="flashcard-dont-know-button"
			>
				<span className="flashcard-app--option-label">
					<ThumbsDown className="icon-super-small" />
					{t("decks.knowDontKnow.dontKnow", "Nie znam")}
				</span>
			</TextButton>
			<TextButton
				onClick={() => animateExit("right", "green", () => resolveFlashcard(1))}
				className={cx("success-text-btn", "flashcard-app--option")}
				data-test-id="flashcard-know-button"
			>
				<span className="flashcard-app--option-label">
					<ThumbsUp className="icon-super-small" />
					{t("decks.knowDontKnow.know", "Znam")}
				</span>
			</TextButton>
		</div>
	);
}
